import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center">
      <div className="w-24 h-24 rounded-3xl bg-primary-50 flex items-center justify-center mb-6">
        <svg className="w-12 h-12 text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z" />
        </svg>
      </div>

      <h1 className="text-4xl font-bold text-surface-900 mb-2">404</h1>
      <h2 className="text-xl font-semibold text-surface-700 mb-3">Page not found</h2>
      <p className="text-surface-500 max-w-md mb-8">
        The page you're looking for doesn't exist or has been moved.
        Let's get you back on track.
      </p>

      <div className="flex items-center gap-3">
        <Link
          to="/"
          className="px-6 py-3 bg-primary-500 text-white rounded-xl font-semibold
            hover:bg-primary-600 transition-colors btn-press shadow-colored"
        >
          Go Home
        </Link>
        <button
          onClick={() => window.history.back()}
          className="px-6 py-3 border border-surface-200 text-surface-700 rounded-xl
            font-medium hover:bg-surface-50 transition-colors"
        >
          Go Back
        </button>
      </div>
    </div>
  );
}

export default NotFound;
